// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QN_E","delete":"styles_delete__3-TlT","update":"styles_update__3R45J","add":"styles_add__1gX8i"};